module.exports = __webpack_public_path__ + "59967f42a8d934f786e5014c6187b847.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin/comments.svg
// module id = 3201
// module chunks = 0 1